<div class="node-graph-container">
  <div class="controls">
    <div class="actions">
      <button (click)="refreshData()" [disabled]="isLoading">
        {{ isLoading ? 'Loading...' : 'Refresh' }}
      </button>
      <button (click)="validateAllNodes()" [disabled]="isLoading || !hasData || validationInProgress || !validationAvailable">
        {{ validationInProgress ? 'Validating...' : 'Validate All Nodes' }}
      </button>
      <button (click)="reloadValidationRules()" [disabled]="isLoading || !hasData || validationInProgress || !validationAvailable">
        Reload Dynamic Rules
      </button>
    </div>

    @if (validationStatus && validationAvailable) {
      <div class="validation-feedback" style="margin-top: 10px; padding: 8px; background-color: #e3f2fd; border-radius: 4px; font-size: 14px;">
        {{ validationStatus }}
      </div>
    }

    <div class="edge-filters">
      <label class="checkbox-label">
        <input
          type="checkbox"
          [(ngModel)]="showAllEdges"
          (change)="onEdgeFilterChange()"
          />
        Show All Edges
      </label>
      @if (!showAllEdges) {
        <label class="checkbox-label">
          <input
            type="checkbox"
            [(ngModel)]="hideUnlockedEdges"
            (change)="onEdgeFilterChange()"
            />
          Hide Unlocked
        </label>
        <label class="checkbox-label">
          <input
            type="checkbox"
            [(ngModel)]="hideSpecificRelationships"
            (change)="onEdgeFilterChange()"
            />
          Hide Named Relationships
        </label>
        <label class="checkbox-label">
          <input
            type="checkbox"
            [(ngModel)]="hideDeletedRelationships"
            (change)="onEdgeFilterChange()"
            />
          Hide "Deleted" Relationships
        </label>
      }
    </div>

    <div class="info">
      @if (nodeCount > 0) {
        <span>Nodes: {{ nodeCount }} | Edges: {{ edgeCount }}</span>
        @if (currentModuleId) {
          <span> | Module: {{ currentModuleId }}</span>
        }
      }
      @if (!hasData && !isLoading) {
        <div class="debug-info" style="font-size: 12px; color: #666; margin-top: 10px;">
          <div>State data input length: {{ stateData?.length || 0 }}</div>
          <div>Has error: {{ !!errorMessage }}</div>
          <div>Current module ID: {{ currentModuleId || 'Not set' }}</div>
        </div>
      }
    </div>

  </div>

  @if (errorMessage) {
    <div class="error">
      {{ errorMessage }}
    </div>
  }

  @if (isLoading && !hasData) {
    <div class="loading-message">
      Loading state data...
    </div>
  }

  @if (!isLoading && !hasData && !errorMessage) {
    <div class="no-data-message">
      No state data available. Please check if this module has states configured.
    </div>
  }

  <div class="main-content">
    <div #networkContainer class="network-container" style="width: 100%; height: 600px; border: 1px solid #ccc;"></div>

    @if (showSidebar) {
      <div class="sidebar">
        <div class="sidebar-header">
          <h3>{{ selectedNode ? 'Node Details' : 'Edge Details' }}</h3>
          <button class="close-btn" (click)="closeSidebar()">&times;</button>
        </div>
        @if (selectedNode) {
          <div class="sidebar-content">
            <div class="section">
              <h4>State Information</h4>
              <p><strong>ModuleState ID:</strong> {{ selectedNode.Id }}</p>
              <p><strong>Name:</strong> {{ selectedNode.Name }}</p>
              <p><strong>Module:</strong> {{ selectedNode.ModuleUniqueId }}</p>
              <p><strong>Version:</strong> {{ selectedNode.Version }}</p>
              <p><strong>Status:</strong> {{ selectedNode.ModuleStatus_Description }}</p>
              <p><strong>Global Status:</strong> {{ selectedNode.GlobalStatus_Description }}</p>
              <p><strong>Initial State:</strong> {{ selectedNode.IsInitialState ? 'Yes' : 'No' }}</p>
              <p><strong>Sign-off State:</strong> {{ selectedNode.IsSignOffState ? 'Yes' : 'No' }}</p>
              <p><strong>Publishable:</strong> {{ selectedNode.IsPublishable ? 'Yes' : 'No' }}</p>
            </div>
            @if (nodeValidation && validationAvailable) {
              <div class="section">
                <h4>Transition Validation</h4>
                <div class="validation-result">
                  <div class="validation-header">
                    <span class="validation-status" [class.valid]="nodeValidation.canProgress" [class.blocked]="!nodeValidation.canProgress">
                      {{ nodeValidation.canProgress ? '✓ Can Progress' : '⚠ Blocked' }}
                    </span>
                    <div class="validation-summary">
                      {{ nodeValidation.analysisDetails.validCombinations }}/{{ nodeValidation.analysisDetails.totalCombinations }} transitions valid
                      @if (!showAllEdges) {
                        <span class="filter-hint">(filtered)</span>
                      }
                    </div>
                  </div>
                  @if (nodeValidation.blockingConditions.length > 0) {
                    <div class="blocking-conditions">
                      <h5>Blocking Conditions:</h5>
                      @for (condition of nodeValidation.blockingConditions; track condition) {
                        <div class="blocking-item">{{ condition }}</div>
                      }
                    </div>
                  }
                  @if (nodeValidation.warnings.length > 0) {
                    <div class="validation-warnings">
                      <h5>Warnings:</h5>
                      @for (warning of nodeValidation.warnings; track warning) {
                        <div class="warning-item">{{ warning }}</div>
                      }
                    </div>
                  }
                  @if (nodeValidation.transitionAnalysis.length > 0) {
                    <div class="transition-analysis">
                      <h5>Transition Details:</h5>
                      @for (transition of nodeValidation.transitionAnalysis; track transition) {
                        <div
                          class="transition-item"
                          [class.valid-transition]="transition.canProgress"
                          [class.blocked-transition]="!transition.canProgress">
                          <div class="transition-header">
                            <span class="transition-name">{{ transition.transitionName }}</span>
                            <span class="transition-status">{{ transition.canProgress ? '✓' : '✗' }}</span>
                          </div>
                          @if (getObjectKeys(transition.validValues).length > 0) {
                            <div class="values-summary">
                              @for (alias of getObjectKeys(transition.validValues); track alias) {
                                <div class="alias-values">
                                  <strong>{{ alias }}:</strong>
                                  @if (transition.validValues[alias].length > 0) {
                                    <span class="valid-values">Valid: {{ transition.validValues[alias].join(', ') }}</span>
                                  }
                                  @if (transition.blockedValues[alias] && transition.blockedValues[alias].length > 0) {
                                    <span class="blocked-values">Blocked: {{ transition.blockedValues[alias].join(', ') }}</span>
                                  }
                                </div>
                              }
                            </div>
                          }
                        </div>
                      }
                    </div>
                  }
                  <button class="config-btn" (click)="openValidationConfig()">Configure Validation</button>
                </div>
              </div>
            }
            @if (nodeSteps.length > 0) {
              <div class="section">
                <h4>Available Steps</h4>
                @for (step of nodeSteps; track step) {
                  <div class="item">
                    <strong>{{ step.Name }}</strong>
                    @if (step.StepTypes) {
                      <p>Types: {{ step.StepTypes }}</p>
                    }
                    <span class="badge">{{ step.IsRequired ? 'Required' : 'Optional' }}</span>
                  </div>
                }
              </div>
            }
            @if (nodeFields.length > 0) {
              <div class="section">
                <h4>Available Fields</h4>
                @for (field of nodeFields; track field) {
                  <div class="item">
                    <strong>{{ field.Name }}</strong> ({{ field.DataType }})
                    @if (field.Description) {
                      <p>{{ field.Description }}</p>
                    }
                    <div class="field-props">
                      @if (field.IsRequired) {
                        <span class="badge required">Required</span>
                      }
                      @if (field.IsReadOnly) {
                        <span class="badge readonly">Read Only</span>
                      }
                      @if (field.IsEditable) {
                        <span class="badge editable">Editable</span>
                      }
                      @if (field.IsAlwaysEditableAtState) {
                        <span class="badge always-editable">Always Editable</span>
                      }
                      @if (field.DefaultValue) {
                        <span class="default-value">Default: {{ field.DefaultValue }}</span>
                      }
                    </div>
                  </div>
                }
              </div>
            }
          </div>
        }
        @if (selectedEdge) {
          <div class="sidebar-content">
            <div class="section">
              <h4>Transition Information</h4>
              <p><strong>Name:</strong> {{ selectedEdge.Name }}</p>
              <p><strong>Description:</strong> {{ selectedEdge.Description || 'No description' }}</p>
              <p><strong>From:</strong> {{ selectedEdge.FromStateName }}</p>
              <p><strong>To:</strong> {{ selectedEdge.ToStateName }}</p>
              <p><strong>Approval Transition:</strong> {{ selectedEdge.IsApprovalTransition ? 'Yes' : 'No' }}</p>
              <p><strong>Rejection Transition:</strong> {{ selectedEdge.IsRejectionTransition ? 'Yes' : 'No' }}</p>
            </div>
            @if (selectedEdge.SaveButton_Label) {
              <div class="section">
                <h4>Save Button Configuration</h4>
                <p><strong>Label:</strong> {{ selectedEdge.SaveButton_Label }}</p>
                <p><strong>Enabled:</strong> {{ selectedEdge.SaveButton_Enabled ? 'Yes' : 'No' }}</p>
                <p><strong>Style:</strong> {{ selectedEdge.SaveButton_Style }}</p>
                <p><strong>Unlock:</strong> {{ selectedEdge.SaveButton_IsUnlock ? 'Yes' : 'No' }}</p>
                <p><strong>Move Next:</strong> {{ selectedEdge.SaveButton_MoveNext ? 'Yes' : 'No' }}</p>
              </div>
            }
            @if (getPostConditions().length > 0) {
              <div class="section">
                <h4>Post Conditions (Field Changes)</h4>
                @for (postCondition of getPostConditions(); track postCondition) {
                  <div class="item">
                    <code>{{ postCondition.RuleExpression }}</code>
                    @if (postCondition.ErrorMessage) {
                      <p class="description">{{ postCondition.ErrorMessage }}</p>
                    }
                  </div>
                }
              </div>
            }
            @if (edgeRules.length > 0) {
              <div class="section">
                <h4>All Rules (Debug)</h4>
                <div class="debug-info">
                  <p>Total rules found: {{ edgeRules.length }}</p>
                  <p>Rule types: {{ getRuleTypesString() }}</p>
                  <p>System Rules: {{ getPreConditionRules().length }} (JSON IDs: {{ getSystemRuleIds() }})</p>
                </div>
              </div>
            }
            @if (getPreConditionRules().length > 0) {
              <div class="section">
                <h4>System Rules from SYSTEM_State_Rules ({{ getPreConditionRules().length }})</h4>
                @for (rule of getPreConditionRules(); track rule) {
                  <div class="item system-rule-item">
                    <div class="rule-header">
                      @if (rule.JsonId || rule.RuleId) {
                        <span class="rule-id">Rule ID: {{ rule.JsonId || rule.RuleId }}</span>
                      }
                      <span class="badge">{{ rule.IsActive ? 'Active' : 'Inactive' }}</span>
                      @if (rule.IsValid !== undefined) {
                        <span class="badge validity" [class.invalid]="!rule.IsValid">{{ rule.IsValid ? 'Valid' : 'Invalid' }}</span>
                      }
                    </div>
                    @if (rule.RuleExpression && rule.RuleExpression !== 'JSON Rule') {
                      <div class="rule-expression">
                        <strong>Rule Name: {{ rule.RuleExpression }}</strong>
                      </div>
                    }
                    @if (rule.ErrorMessage && rule.ErrorMessage !== rule.RuleExpression && rule.ErrorMessage !== 'System rule (see JSON)') {
                      <div class="rule-conditions">
                        <strong>Parsed Conditions:</strong>
                        <code>{{ rule.ErrorMessage }}</code>
                      </div>
                    }
                    @if (rule.OperationType) {
                      <div class="operation-info">
                        <strong>Operation:</strong> {{ rule.OperationType }}
                      </div>
                    }
                    @if (rule.ConditionCount) {
                      <div class="condition-count">
                        <strong>Conditions:</strong> {{ rule.ConditionCount }}
                      </div>
                    }
                    @if (rule.FullRuleJson) {
                      <div class="json-preview">
                        <button class="json-toggle" (click)="toggleJsonView(rule)">
                          {{ rule.showJson ? 'Hide' : 'Show' }} Raw JSON
                        </button>
                        @if (rule.showJson) {
                          <pre class="json-content">{{ rule.FullRuleJson }}</pre>
                        }
                      </div>
                    }
                  </div>
                }
              </div>
            }
            @if (getTriggerFields().length > 0) {
              <div class="section">
                <h4>Trigger Fields</h4>
                @for (field of getTriggerFields(); track field) {
                  <div class="item">
                    <strong>{{ field.RuleExpression }}</strong>
                    @if (field.ErrorMessage) {
                      <p class="description">{{ field.ErrorMessage }}</p>
                    }
                  </div>
                }
              </div>
            }
            @if (getRequiredPermissions().length > 0) {
              <div class="section">
                <h4>Required Permissions</h4>
                @for (permission of getRequiredPermissions(); track permission) {
                  <div class="item">
                    <strong>{{ permission.RuleExpression }}</strong>
                    @if (permission.ErrorMessage) {
                      <p class="description">{{ permission.ErrorMessage }}</p>
                    }
                  </div>
                }
              </div>
            }
          </div>
        }
      </div>
    }
  </div>
</div>